import React, { FunctionComponent } from 'react';
import { ApiDataBinding, withApiData } from 'react-api-data';
import { ApiResponse, CrossIxConnection } from 'constants/api';
import { useTranslation } from 'react-i18next';
import { compose } from 'recompose';
import { Roles } from 'constants/literals';
import RequestStatusRenderer from './RequestStatusRenderer';
import { getLinkToCrmCrossIxConnection } from 'utils/linksUtils';
import { Link } from 'react-router-dom';
import withUserRoles from 'hocs/withUserRoles';
import { hasSomeRole } from 'utils/userUtils';

interface InProps {
    cross_ix_connection_uuid: string;
}

interface EnhanceProps {
    crossIxConnectionRequest: ApiDataBinding<ApiResponse<CrossIxConnection>>;
    userRoles: Roles[];
}

type Props = InProps & EnhanceProps;

const enhance = compose<Props, InProps>(
    withApiData(
        {
            crossIxConnectionRequest: 'getCrmCrossIxConnection'
        },
        (ownProps: InProps) => ({
            crossIxConnectionRequest: { uuid: ownProps.cross_ix_connection_uuid }
        })
    ),
    withUserRoles
);

const CrossIxConnectionXmlId: FunctionComponent<Props> = ({ crossIxConnectionRequest, userRoles }) => {
    const { t } = useTranslation();

    return (
        <RequestStatusRenderer
            request={crossIxConnectionRequest}
            success={() => {
                const { uuid, xml_id } = crossIxConnectionRequest.data!.data!;

                if (hasSomeRole(userRoles, Roles.admin, Roles.noc, Roles.ixaas_client, Roles.ixaas_client_reader)) {
                    return (
                        <strong>{t('crossIxConnectionXmlId.crossIxConnection')} <a href={getLinkToCrmCrossIxConnection(uuid)}>{xml_id}</a></strong>
                    );
                } else {
                    return (
                        <strong>{t('crossIxConnectionXmlId.crossIxConnection')} {xml_id}</strong>
                    );
                }
            }}
            failed={() => <div className="badge badge-danger">{t('crossIxConnectionXmlId.failedToFetch')}</div>}
        />
    );
};

export default enhance(CrossIxConnectionXmlId);

